import url from './url';



export default url(() => '/mixins-experiments/create');
